import IpWhiteList, { IpWhiteListState } from '@models/IpWhiteList';
import { I18NextPipe } from 'angular-i18next';
import { TableHeader } from 'mbs-ui-kit';
import { IPUtils } from 'mbs-ui-shared@utils/ip';

export const createTableHeaders = (i18N: I18NextPipe): TableHeader[] => [
  {
    name: i18N.transform('shared:common.name', { format: 'title' }),
    overflow: true,
    gridColSize: '7fr',
    gridColMin: '152px',
    sort: 'name'
  },
  {
    name: i18N.transform('mbs-ui:ipWhiteList.ipRange'),
    overflow: true,
    gridColSize: '10fr'
  },
  {
    name: '',
    gridColSize: '90px',
    class: '-end'
  }
];

export const parseRanges = (rawRange: string): Partial<IpWhiteList> => {
  const result: { ips: string[]; ipRanges: string[] } = { ipRanges: [], ips: [] };
  const preparedRowRange = rawRange.replace(/^\s+|\s+$/g, '').replace(/\s{2,}/g, ' ');
  const rows = preparedRowRange.split(/[,\n]/).filter((r) => !!r.trim());
  for (let i = 0; i < rows.length; i++) {
    const r = rows[i];
    if (r.includes('-')) {
      result.ipRanges.push(r);
    } else {
      result.ips.push(r);
    }
  }

  return result;
};

export const haveCombinedIPError = (value: string): boolean => {
  const ipsRows = splitIPValue(value);

  return (
    ipsRows.some((ipsRow) => {
      return ipsRow.split('-').some((ip) => IPUtils.isV4(ip));
    }) &&
    ipsRows.some((ipsRow) => {
      return ipsRow.split('-').some((ip) => IPUtils.isV6(ip));
    })
  );
};

export const haveInvalidIPError = (value: string): boolean => {
  return splitIPValue(value).some((ipsRow) => {
    const ipRange = ipsRow.split('-');

    return (
      ipRange.length > 2 ||
      (ipRange.length === 2 && IPUtils.compareIPs(ipRange[0], ipRange[1]) > 0) ||
      ipRange.map((ip) => ip.trim()).some((ip) => !((IPUtils.isV4(ip) && ip.includes('.')) || IPUtils.isV6(ip)))
    );
  });
};

const splitIPValue = (value: string) =>
  String(value)
    .split(/[,\n]/)
    .map((ip) => ip.trim())
    .filter((ip) => !!ip);

export const haveIntersectedIPError = (value: string, data: IpWhiteList[]): boolean => {
  const newRanges = parseRanges(value);

  return (
    newRanges.ips.some((ip, index) => newRanges.ips.some((ip2, index2) => index !== index2 && IPUtils.containsIpInRange(ip2, [ip, ip]))) ||
    newRanges.ips.some((ip) => newRanges.ipRanges.some((ipRange) => IPUtils.containsIpInRange(ip, ipRange.split('-')))) ||
    newRanges.ipRanges.some((ipRange, index) =>
      newRanges.ipRanges.some((ipRange2, index2) => {
        const range1 = ipRange.split('-');
        const range2 = ipRange2.split('-');

        return (
          index !== index2 &&
          (IPUtils.containsIpInRange(range1[0], range2) ||
            IPUtils.containsIpInRange(range1[1], range2) ||
            IPUtils.containsIpInRange(range2[0], range1) ||
            IPUtils.containsIpInRange(range2[1], range1))
        );
      })
    ) ||
    data
      .filter((d) => d.state != IpWhiteListState.Delete)
      .some(
        (row) =>
          (row.ips || []).some(
            (ip) =>
              newRanges.ips.some((newRangeIP) => IPUtils.containsIpInRange(newRangeIP, [ip, ip])) ||
              newRanges.ipRanges.some((newRange) => IPUtils.containsIpInRange(ip, newRange.split('-')))
          ) ||
          (row.ipRanges || []).some(
            (range) =>
              newRanges.ips.some((newRangeIP) => IPUtils.containsIpInRange(newRangeIP, range.split('-'))) ||
              newRanges.ipRanges.some((newRange) => {
                const range1 = range.split('-');
                const range2 = newRange.split('-');

                return (
                  IPUtils.containsIpInRange(range1[0], range2) ||
                  IPUtils.containsIpInRange(range1[1], range2) ||
                  IPUtils.containsIpInRange(range2[0], range1) ||
                  IPUtils.containsIpInRange(range2[1], range1)
                );
              })
          )
      )
  );
};
